import { render, staticRenderFns } from "./LivingBody.vue?vue&type=template&id=9a88fb5a&scoped=true&"
import script from "./LivingBody.vue?vue&type=script&lang=js&"
export * from "./LivingBody.vue?vue&type=script&lang=js&"
import style0 from "./LivingBody.vue?vue&type=style&index=0&id=9a88fb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a88fb5a",
  null
  
)

export default component.exports